/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Region_LumbarInputs */

const en_us2_bodymap_region_lumbar = /** @type {(inputs: Bodymap_Region_LumbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lower back`)
};

const pt_br2_bodymap_region_lumbar = /** @type {(inputs: Bodymap_Region_LumbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lombar`)
};

const es_419_bodymap_region_lumbar = /** @type {(inputs: Bodymap_Region_LumbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zona lumbar`)
};

const pt_pt2_bodymap_region_lumbar = /** @type {(inputs: Bodymap_Region_LumbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lombar`)
};

const fr_fr2_bodymap_region_lumbar = /** @type {(inputs: Bodymap_Region_LumbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bas du dos`)
};

const de_de2_bodymap_region_lumbar = /** @type {(inputs: Bodymap_Region_LumbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterer Rücken`)
};

const it_it2_bodymap_region_lumbar = /** @type {(inputs: Bodymap_Region_LumbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zona lombare`)
};

/**
* | output |
* | --- |
* | "Lower back" |
*
* @param {Bodymap_Region_LumbarInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_region_lumbar = /** @type {((inputs?: Bodymap_Region_LumbarInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Region_LumbarInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_region_lumbar(inputs)
	if (locale === "es-419") return es_419_bodymap_region_lumbar(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_region_lumbar(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_region_lumbar(inputs)
	if (locale === "de-DE") return de_de2_bodymap_region_lumbar(inputs)
	if (locale === "it-IT") return it_it2_bodymap_region_lumbar(inputs)
	return en_us2_bodymap_region_lumbar(inputs)
});
export { bodymap_region_lumbar as "bodymap.region.lumbar" }